import * as React from "react";
import {connect, Provider} from "react-redux";
import server from "../../../../../integration/server/server-services";
import {applyMiddleware, createStore} from "redux";
import {default as reducers} from "../../../admin/groups/reducers";
import {
    GetContractGroups,
    getContractGroups, initGroupAdmin, InitGroupAdmin,
} from "../actions";
import GroupAdminState, {ContractGroup} from "../GroupAdminState";
import thunk from "redux-thunk";
import {GroupSelector} from "./group-selector";
import {UserManager} from "./user-manager";
import {ContractManager} from "./contract-manager";
import * as selectors from "../selectors";
import security from "../../../../../service/security/security-services";
import {Fetch} from "../../../../../service/Fetch";


export class ServerHolder {
    constructor(
        public security: security = null,
        public server: server = null,
        public scope: angular.IRootScopeService = null,
        public fetch: Fetch = null
    ) {
    }
}

const serverHolder = new ServerHolder();
const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)));

interface StateProps {
    contractGroups: ContractGroup[],
    hasViewPermission: boolean,
    isLoading: boolean,
}

interface DispatchProps {
    doGetContractGroups: GetContractGroups,
    doInitGroupAdmin: InitGroupAdmin
}

type Props = DispatchProps & StateProps;

interface GroupsAdminProps {
    server: server,
    security: security,
    $rootScope: any,
}


class GroupsdAdminView extends React.Component<Props, {}> {

    componentWillMount(): void {
        this.props.doInitGroupAdmin();
    }

    render() {

        let {hasViewPermission, isLoading} = this.props;

        return (
            <div id="group-admin">

                <h1>Kontraktgrupper og brukere</h1>

                {isLoading && (
                    <div className="cssloader-blocking">
                        <div className="cssloader"/>
                    </div>
                )}

                {(hasViewPermission && !isLoading) &&
                <div>
                    <GroupSelector/>
                    <div className="list-container">
                        <ContractManager/>
                        <UserManager/>
                    </div>
                </div>
                }

                {(!hasViewPermission && !isLoading) &&
                <div>Du mangler tilgang til gruppeadministrering</div>
                }

            </div>
        );
    }

}


export class GroupsAdmin extends React.Component<GroupsAdminProps, {}> {
    render() {

        const mapStateToProps = (state: GroupAdminState) => {
            return {
                contractGroups: selectors.contractGroups(state),
                hasViewPermission: selectors.userCanViewGroups(state),
                isLoading: selectors.isLoading(state),
            }
        };

        const mapDispachToProps = ({
            doInitGroupAdmin: initGroupAdmin,
            doGetContractGroups: getContractGroups,
        });

        serverHolder.security = this.props.security;
        serverHolder.server = this.props.server;
        serverHolder.scope = this.props.$rootScope;
        serverHolder.fetch = new Fetch("", this.props.$rootScope);

        const GroupsAdmin = connect(mapStateToProps, mapDispachToProps)(GroupsdAdminView);
        return (
            <Provider store={store} key="provider">
                <GroupsAdmin/>
            </Provider>
        )
    }
}
